export airportsBySiteReducer = (state = {}, action) -> state
